import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/PDFViewer.css";

const PDFViewer = () => {
  const { pdfLink } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [iframeUrl, setIframeUrl] = useState("");
  const [isGoogleDoc, setIsGoogleDoc] = useState(false);

  // Decode the link to get a clean display name
  const decodedLink = pdfLink ? decodeURIComponent(pdfLink) : "";
  const formattedLinkName = decodedLink
    ? decodedLink.split('/').pop().split('?')[0].replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "Document Viewer";

  useEffect(() => {
    if (!pdfLink) {
      setError("No document link provided.");
      return;
    }

    const decoded = decodeURIComponent(pdfLink);
    
    // Check if it's a Google Docs link
    if (decoded.includes("docs.google.com/document")) {
      setIsGoogleDoc(true);
      
      // Convert to proper embed URL for Google Docs
      const match = decoded.match(/\/d\/([a-zA-Z0-9_-]+)/);
      if (match && match[1]) {
        const fileId = match[1];
        const embedUrl = `https://docs.google.com/document/d/${fileId}/preview`;
        setIframeUrl(embedUrl);
      } else {
        setError("Invalid Google Docs link format.");
      }
    } 
    // Check if it's a PDF file
    else if (decoded.includes(".pdf") || decoded.includes("drive.google.com/file")) {
      setIsGoogleDoc(false);
      
      // Extract file ID from Google Drive link if possible
      let fileId = "";
      const match = decoded.match(/\/d\/([a-zA-Z0-9_-]+)/);
      
      if (match && match[1]) {
        fileId = match[1];
        // Use direct preview link for PDF files
        const previewUrl = `https://drive.google.com/file/d/${fileId}/preview`;
        setIframeUrl(previewUrl);
      } else {
        // For direct PDF links
        setIframeUrl(decoded);
      }
    } else {
      setError("Unsupported document type. Please use Google Docs or PDF files.");
    }
  }, [pdfLink]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleViewerError = () => {
    setError("Failed to display document. Please try opening the link directly.");
  };

  return (
    <div className="pdf-viewer-page">
        <button className="back-button-pdf" onClick={handleGoBack}>
          <i className="fa-solid fa-arrow-left size3"></i>
        </button>

      <div className="pdf-viewer-content">
        {error ? (
          <div className="error-container">
            <p className="error-message">{error}</p>
            {/* Direct link as fallback */}
            <a
              href={decodedLink}
              target="_blank"
              rel="noopener noreferrer"
              className="download-button"
            >
              Open Document Directly
            </a>
          </div>
        ) : (
          <iframe
            key={iframeUrl}
            src={iframeUrl}
            title="Document Viewer"
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ display: "block", minHeight: "600px" }}
            onError={handleViewerError}
          />
        )}
      </div>
    </div>
  );
};

export default PDFViewer;
